import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { App } from 'v3/App';
import { Auth } from 'v3/pages/Auth';
import { Guard } from 'v3/pages/Auth/Guard';
import { LoginPage } from 'v3/pages/Auth/Login';
import { ContractingDetailsPage } from 'v3/pages/Contracting/Details';
import { ContractingListPage } from 'v3/pages/Contracting/List';
import { ContractingPDF } from 'v3/pages/Contracting/PDF';
import { GroupsPage } from 'v3/pages/Groups';
import { GroupsList } from 'v3/pages/Groups/List';
import { OnlinePages } from 'v3/pages/OnlineContracting';
import { OnlineContractingDetailsPage } from 'v3/pages/OnlineContracting/Details';
import { OnlineContractingListPage } from 'v3/pages/OnlineContracting/List';
import { PaymentsDetailsPage } from 'v3/pages/Payments/Details';
import { PaymentsPage } from 'v3/pages/Payments/List';
import { ProductsPage } from 'v3/pages/Products';
import { ProductsListPage } from 'v3/pages/Products/List';
import { Receipt } from 'v3/pages/Receipt';
import { SellerPage } from 'v3/pages/Seller';
import { SellerList } from 'v3/pages/Seller/List';
import { SellersRankingPage } from 'v3/pages/SellersRanking';
import { SellerRankingList } from 'v3/pages/SellersRanking/ListRank';
import { SplashPage } from 'v3/pages/Splash/SplashPage';
import { StoresPage } from 'v3/pages/Stores';
import { CreateStores } from 'v3/pages/Stores/CreateStores';
import { StoresList } from 'v3/pages/Stores/List';
import { RoutesEnum } from 'v3/routes/enum';

export const MainRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={RoutesEnum.Auth} element={<Auth redirectTo={RoutesEnum.Home} />}>
          <Route index element={<LoginPage />} />
        </Route>

        <Route element={<Guard redirectTo={RoutesEnum.HomeAuth} />}>
          <Route path={RoutesEnum.Home} element={<App />}>
            <Route index element={<SplashPage />} />

            <Route path={RoutesEnum.Online} element={<OnlinePages />}>
              <Route path={RoutesEnum.ContractingOnline} element={<OnlineContractingListPage />} />

              <Route
                path={`${RoutesEnum.ContractingOnline}/:origin/:contractingKey`}
                element={<OnlineContractingDetailsPage />}
              />
              <Route
                path={`${RoutesEnum.ContractingOnline}/:contractingKey`}
                element={<OnlineContractingDetailsPage />}
              />
            </Route>

            <Route path={`${RoutesEnum.Contracting}/:contractingKey`} element={<ContractingDetailsPage />} />
            <Route path={`${RoutesEnum.ContractingList}`} element={<ContractingListPage />} />
            <Route path={`${RoutesEnum.PaymentsList}`} element={<PaymentsPage />} />
            <Route path={`${RoutesEnum.Payments}/:contractingKey`} element={<PaymentsDetailsPage />} />

            <Route path={RoutesEnum.Products} element={<ProductsPage />}>
              <Route path={RoutesEnum.ProductsList} element={<ProductsListPage />} />
            </Route>

            <Route path={RoutesEnum.Stores} element={<StoresPage />}>
              <Route path={RoutesEnum.StoresList} element={<StoresList />} />
              <Route path={RoutesEnum.CreateStore} element={<CreateStores />} />
            </Route>

            <Route path={RoutesEnum.Seller} element={<SellerPage />}>
              <Route path={RoutesEnum.SellerList} element={<SellerList />} />
            </Route>

            <Route path={RoutesEnum.SellersRanking} element={<SellersRankingPage />}>
              <Route path={RoutesEnum.SellersRankingList} element={<SellerRankingList />} />
            </Route>

            <Route path={RoutesEnum.Groups} element={<GroupsPage />}>
              <Route path={RoutesEnum.GroupsList} element={<GroupsList />} />
            </Route>
          </Route>

          <Route path={`${RoutesEnum.Receipt}/:contractingKey`} element={<Receipt />} />
          <Route path={RoutesEnum.ContractingPDF} element={<ContractingPDF />} />
        </Route>

        <Route path="*" element={<Navigate to={RoutesEnum.Home} replace />} />
      </Routes>
    </BrowserRouter>
  );
};
